import React, { useEffect, useState } from "react";
import {
  useAddPaymentMutation,
  useOrderByIdQuery,
  useOrdersQuery,
  usePaymentByIdQuery,
  useStatusQuery,
  useCheckInQuery,
} from "../../../Store/Apis/bookingApi";
import Error from "../../../Components/Error/Error";
import Loader from "../../../Components/Loader/Loader";
import { Link, useLocation } from "react-router-dom";
import { useOutletsQuery } from "../../../Store/Apis/outletApi";
import getStatusColor from "../../../Hooks/GetStatusColor";
import {
  isDropdownPermission,
  isPermissionGranted,
} from "../../../Hooks/permissionsMiddleware";
import { Table, Badge } from "antd";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import AddPaymentForm from "../../../Components/AddPaymentForm/AddPaymentForm";
import { useSelector } from "react-redux";
import formatDate from "../../../Hooks/formatDate";
import { useRolesQuery } from "../../../Store/Apis/rolePermissionApi";

const CheckIn = () => {
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search); // Parse the URL parameters
  const statusFromUrl = urlParams.get("status");
  const [sortFilter, setSortFilter] = useState({
    search: "",
    outlet: "",
    status: "",
    status: statusFromUrl || "",
    technicianID: "",
  });

  const bookingApi = useCheckInQuery({
    keyword: sortFilter.search,
    statusName: sortFilter.status,
    outletID: sortFilter.outlet,
    technicianID: sortFilter.technicianID,
  });

  const outletList = useOutletsQuery();
  const statusList = useStatusQuery();
  const roleApi = useRolesQuery();

  // ADD PAYMENT AND UPDATE ORDER
  const [paymentFormModal, setPaymentFormModal] = useState();
  const [addPaymentMutation] = useAddPaymentMutation();

  const orderByIdApi = useCheckInQuery(
    {
      keyID: paymentFormModal?.orderId,
    },
    { skip: !paymentFormModal?.orderId }
  );

  const paymentByIdApi = usePaymentByIdQuery(
    {
      orderId: paymentFormModal?.orderId,
    },
    { skip: !paymentFormModal?.orderId }
  );

  const handleAddPayment = (formData) => {
    console.log(formData);
    addPaymentMutation({
      paymentDate: new Date().toISOString(),
      customerId: orderByIdApi?.data?.data[0].customerID || 0,
      companyID: orderByIdApi?.data?.data[0].companyID || 0,
      customerName: orderByIdApi?.data?.data[0].customerName,
      orderId: paymentFormModal?.orderId,
      receivedAmount: formData.paidAmount,
      payAmount: formData.paidAmount,
      paymentType: formData.paymentType,
      paymentNote: formData.notes,
      utrNumber: formData.utrNumber,
    }).then((res) => {
      console.log(res);
      if (res?.data?.status === 200) {
        setPaymentFormModal(false);
        toast.success(res?.data?.message, { duration: 7000 });
        // navigate('/sales-history');
      } else {
        toast.error(res?.data?.message, { duration: 7000 });
      }
    });
  };

  // Define columns for the Ant Design Table
  const columns = [
    {
      title: "Order Info",
      dataIndex: "orderInfo",
      fixed: "left",
      width: 250,
      render: (_, record) => (
        <>
          <p className="text-sm mb-0">
            <span className="me-2">Order ID:</span>
            <span className="font-weight-bold">{record.orderNumber}</span>
          </p>

          <p className="text-sm mb-0">
            <span className="me-2">Check In Date:</span>
            <span>{formatDate(record.orderDate)}</span>
          </p>
          <p className="text-sm mb-0">
            <span className="me-2">Check Out Date:</span>
            <span>{formatDate(record.checkOutDate)}</span>
          </p>
        </>
      ),
    },
    // {
    //     title: 'Outlet',
    //     dataIndex: 'outletName',
    // },
    {
      title: "Customer",
      dataIndex: "customer",
      render: (_, record) => (
        <>
          <p className="text-sm font-weight-bold mb-0">{record.customerName}</p>
          <p className="text-sm mb-0">{record.customerNumber}</p>
        </>
      ),
    },
    // {
    //     title: 'Order Amount',
    //     dataIndex: 'subTotal',
    //     render: (subTotal) => `R ${subTotal}`,
    // },
    {
      title: "Status",
      dataIndex: "statusDescription",
      render: (status) => (
        <span
          className={`badge badge-sm text-uppercase badge-${getStatusColor(
            status
          )}`}
          style={{ cursor: "default" }}
        >
          {status}
        </span>
      ),
    },
    {
      title: "Payment",
      dataIndex: "payment",
      render: (_, record) => (
        <>
          <p className="text-sm mb-0">
            <span className="me-2">Total Amount:</span>
            <span className="font-weight-bold">R {record.subTotal}</span>
          </p>
          <p className="text-sm mb-0">
            <span className="me-2">Paid Amount:</span>
            <span className="font-weight-bold">R {record.amountPaid}</span>{" "}
            <br />
            {isPermissionGranted(5) &&
              record.subTotal !== record.amountPaid && (
                <span
                  className="badge badge-xs badge-success text-xs fw-600 mt-2"
                  onClick={() => setPaymentFormModal(record)}
                >
                  Add Payment
                </span>
              )}
          </p>
        </>
      ),
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      render: (_, record) => (
        <p className="text-sm mb-0">{record.createdByName}</p>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      fixed: "right",
      width: 150,
      render: (_, record) => (
        <>
          {isPermissionGranted(2) && (
            <Link
              to={`/sales-history/details?id=${record.orderId}`}
              className="badge badge-xs badge-primary text-xs fw-600 mx-1"
            >
              View
            </Link>
          )}
          {isPermissionGranted(1) &&
            record.statusDescription !== "Completed" &&
            (() => {
              // Internal booking: only creator can edit
              if (record.createdBy.toString() !== "0") {
                return record.createdBy.toString() === user.id.toString();
              }
              // External booking (createdBy === 0): only reservationist role can edit
              const userRoleName = String(
                user?.role || user?.roleName || ""
              ).toLowerCase();
              return userRoleName === "reservationist";
            })() && (
              <Link
                to={`/sales-history/edit?id=${record.orderId}`}
                className="badge badge-xs badge-warning text-xs fw-600 mx-1"
              >
                Edit
              </Link>
            )}
        </>
      ),
    },
  ];

  // Transform data to fit the Ant Design table structure
  const dataSource = bookingApi?.data?.data?.map((elem, index) => ({
    key: index,
    orderNumber: elem.orderNumber,
    orderDate: elem.orderDate,
    checkOutDate: elem.checkOutDate,
    outletName: elem.outletName,
    customerName: elem.customerName,
    customerNumber: elem.customerNumber,
    subTotal: Number(elem.subTotal + elem.taxAmount - elem.discount).toFixed(2),
    statusDescription: elem.statusDescription,
    amountPaid: Number(elem.amountPaid).toFixed(2),
    totalAmount: Number(elem.totalAmount).toFixed(2),
    orderId: elem.orderId,
    createdBy: elem.createdBy,
    createdByName: elem.createdByName,
  }));

  useEffect(() => {
    if (user.role !== "superAdmin") {
      setSortFilter({
        ...sortFilter,
        outlet: user.outletID,
        status: statusFromUrl || sortFilter.status,
      });
    }
    if (roleApi.isSuccess && user.role === "Technician") {
      const technicianRole = roleApi.data?.data?.find(
        (elem) => elem.roleName === "Technician"
      );
      setSortFilter({
        ...sortFilter,
        technicianID: technicianRole?.roleID === user.role_Id ? user.id : "",
        status: statusFromUrl || sortFilter.status,
      });
    }
  }, [roleApi.isSuccess, statusFromUrl]);

  return (
    <div>
      <div className="row align-items-center justify-content-between mb-4">
        <div className="col">
          <h5 className="fw-500 text-white mb-0">Sales History</h5>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card mb-4">
            <div className="card-header p-4">
              <div className="row">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Order Id, Outlet and Customer"
                    value={sortFilter?.search || ""}
                    onChange={(e) =>
                      setSortFilter({ ...sortFilter, search: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-3">
                  <select
                    className="form-select"
                    disabled={
                      !outletList.isSuccess ||
                      !isDropdownPermission(user.role_Id)
                    }
                    value={sortFilter?.outlet}
                    onChange={(e) =>
                      setSortFilter({ ...sortFilter, outlet: e.target.value })
                    }
                  >
                    <option className="select-box" value="">
                      All Outlets
                    </option>
                    {outletList?.data?.data.map((elem) => {
                      return (
                        <option value={elem.outletId}>{elem.outletName}</option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-md-3">
                  <select
                    className="form-select"
                    value={sortFilter?.status || ""}
                    onChange={(e) =>
                      setSortFilter({ ...sortFilter, status: e.target.value })
                    }
                  >
                    <option className="select-box" value="">
                      All Bookings
                    </option>
                    {statusList?.data?.data.map((elem, i) => {
                      return (
                        <option className="select-box" value={elem.description}>
                          {elem.description}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {bookingApi.isError && <Error />}
              {bookingApi.isLoading && <Loader height="500px" />}
              {bookingApi.isSuccess && (
                <Table
                  columns={columns}
                  dataSource={dataSource}
                  pagination={{ pageSize: 10 }}
                  className="mx-4"
                  scroll={{ x: 1500 }}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* PAYMENT FORM MODAL */}
      <Modal
        show={paymentFormModal}
        onHide={() => setPaymentFormModal(null)}
        size="lg"
        centered
      >
        <Modal.Body>
          <h4 className="mb-4 fs-5">Payment Details</h4>
          {((orderByIdApi.isLoading && paymentByIdApi.isLoading) ||
            (orderByIdApi.isFetching && paymentByIdApi.isFetching)) && (
            <Loader height={500} />
          )}
          {orderByIdApi.isSuccess &&
            paymentByIdApi.isSuccess &&
            !orderByIdApi.isFetching &&
            !paymentByIdApi.isFetching && (
              <AddPaymentForm
                handleSubmit={handleAddPayment}
                totalAmount={orderByIdApi?.data?.data[0].subTotal}
                setPaymentFormModal={setPaymentFormModal}
                data={{
                  discountType: paymentFormModal?.discountType,
                  discount: orderByIdApi?.data?.data[0].discount,
                  paidAmount: orderByIdApi?.data?.data[0].amountPaid,
                  paymentType: paymentByIdApi?.data?.data[0].paymentType,
                  utrNumber: paymentByIdApi?.data?.data[0].utrNumber,
                  notes: paymentByIdApi?.data?.data[0].notes,
                  specialInstruction: "",
                  orderId: orderByIdApi?.data?.data[0].orderId,
                  paidAmount: paymentByIdApi?.data?.data.reduce(
                    (acc, payment) => acc + payment.amount,
                    0
                  ),
                }}
              />
            )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CheckIn;
